import {CartProductItem} from 'modules/Cart/components/CartProductItem/CartProductItem';
import {useOrderSuccess} from 'modules/Cart/hooks/useOrderSuccess';
import {FC} from 'react';

import {Text} from 'components/Text/Text';

import styles from './OrderedProducts.module.css';

type Props = {};
export const OrderedProducts: FC<Props> = () => {
    const {products} = useOrderSuccess();

    return (
        <div className={styles.block}>
            <Text.Bold24 className={styles.title}>
                Заказанные товары
            </Text.Bold24>
            <div className={styles.list}>
                {products.map((product) => (
                    <CartProductItem
                        key={product.id}
                        className={styles.product}
                        data={product}
                        amount={product.count}
                        removed={false}
                        checked={true}
                        readonly
                    />
                ))}
            </div>
        </div>
    );
};
